import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.TestPortions.WaterAddedTarget`]: wrap([`${prefix}.TestPortions.PortionMass`]),
  [`${prefix}.TestPortions.WetSoilMass`]: wrap([
    `data.TestPortions.MouldMass`,
    `data.TestPortions.WetSoilAndContainerMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
